module.exports = __webpack_public_path__ + "static/media/team2.d42e6505.jpg";